/**
 * Ryan O'Dowd
 * 2024-11-11
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = () => {
  return {
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flext-start',
      margin: 12,
    },
  };
};

export default getStyles;
